/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const OTPLoginResponseParser = /* #__PURE__ */ parsers.object([
    ['id', codecString],
]);
export class OTPLoginResponse extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return OTPLoginResponseParser.decode(input).map(res => new OTPLoginResponse(res));
    }
    static unsafeDecode(input) {
        return OTPLoginResponse.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return OTPLoginResponseParser.encode(data);
    }
    static schema() {
        return OTPLoginResponseParser.schema();
    }
}
